

























































































import ModalTabMixin from '@/mixins/modal-tab.mixin';
import { CrsForm } from '@resclick/crs-ui';
import { compass } from '@resclick/compass';
import { IWidget } from '@resclick/data-access';
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { i18n } from '@/i18n';

@Component
export default class TabGeneral extends Mixins(ModalTabMixin) {
  @Prop({ required: true }) propertyId!: string;
  extras = [];
  form!: CrsForm<'properties', 'createWidget' | 'updateWidget'>;

  get additionalProductsOptions() {
    return [
      { label: i18n.tc('GENERAL.FLIGHT'), value: 'FLIGHTS' },
      { label: i18n.tc('GENERAL.TRANSFER'), value: 'TRANSFERS' },
      { label: i18n.tc('GENERAL.CANCELLATION_INSURANCE'), value: 'CANCELLATION_INSURANCES' },
      { label: i18n.tc('GENERAL.PACKAGE'), value: 'PACKAGES' },
      { label: i18n.tc('GENERAL.ACTIVITY'), value: 'ACTIVITIES' },
    ];
  }

  get widgetTypeOptions() {
    return [
      { label: i18n.t('GENERAL.BOOKING_WIDGET'), value: 'BOOKING_WIDGET' },
      { label: i18n.t('GENERAL.POPUP_WIDGET'), value: 'POPUP_WIDGET' },
      { label: i18n.t('GENERAL.CALL_ME_WIDGET'), value: 'CALL_ME_WIDGET' },
      { label: i18n.t('GENERAL.ONLINE_SUPPORT_WIDGET'), value: 'ONLINE_SUPPORT_WIDGET' },
    ];
  }

  getForm() {
    return compass.do('properties', 'findOneWidget', {
      params: { propertyId: this.propertyId, widgetId: this.id as string },
    });
  }

  created() {
    this.form = this.$crsForm('properties', this.mode === 'create' ? 'createWidget' : 'updateWidget', {
      isActive: false,
      name: '',
      type: 'BOOKING_WIDGET',
      phoneNumber: '',
      effect: 'TOGGLE',
      theme: 'VERTICAL_V1',
      actionURL: '',
      style: {
        bgColor: '#ffffff',
        colorPrimary: '#294f8d',
        inputBgColor: '#ffffff',
        toggleTextColor: '#ffffff',
        btnBgColor: '#ffa500',
        btnTextColor: '#ffffff',
      },
      additionalProducts: ['FLIGHTS', 'TRANSFERS', 'CANCELLATION_INSURANCES', 'PACKAGES', 'ACTIVITIES'],
    });

    this.$once('update-data', (data: Omit<IWidget, 'property'>) => {
      this.form = this.$crsForm('properties', 'updateWidget', data);
    });
  }
}
